<script lang="ts">
	import type { Snippet } from "svelte";
	let { columnTitle, children }: { columnTitle: string; children: Snippet } = $props();
</script>

<div class="grow">
	<span class="text-background text-sm/6 font-semibold">{columnTitle}</span>
	<ul role="list" class="mt-6 space-y-4">
		{@render children?.()}
	</ul>
</div>
